module.exports = __webpack_public_path__ + "img/UC-logo.166b1a20.png";